module.exports = __webpack_public_path__ + "media/packs/images/flags/DJ-77b77049ca1b1e7d5585fdb957ec4e99.png";